// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L8MomkVau8G63_guXQNb{flex-direction:column;justify-content:center;align-items:center;width:100%;display:flex}.nRzCVV6V8CMzDnX9gY82{color:var(--content-neutral-primary);margin-bottom:16px}.M9SswzNrH8A0p1VkXATg{gap:8px;margin-top:20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `L8MomkVau8G63_guXQNb`,
	"icon": `nRzCVV6V8CMzDnX9gY82`,
	"actions": `M9SswzNrH8A0p1VkXATg`
};
export default ___CSS_LOADER_EXPORT___;
